import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Noticeboard from './pages/Noticeboard';
import About from './pages/About';
import Join from './pages/Join';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Login from './pages/Login';
import Admin from './pages/admin/Admin';
import AreaMap from './pages/AreaMap';

function App() {
  return (
    <Router>
      <Navbar />
      <main className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/noticeboard" element={<Noticeboard />} />
          <Route path="/about" element={<About />} />
          <Route path="/join" element={<Join />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/map" element={<AreaMap />} />
          {/* Legacy redirects */}
          <Route path="/news" element={<Navigate to="/noticeboard" replace />} />
          <Route path="/events" element={<Navigate to="/noticeboard" replace />} />
          <Route path="/committee" element={<Navigate to="/about" replace />} />
          <Route path="/documents" element={<Navigate to="/about" replace />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
